module.exports = __webpack_public_path__ + "static/media/train-0-0-wheel-small.d51d7700.png";